module.exports = __webpack_public_path__ + "img/hero-player.878ee8c9.png";